import "nette.ajax.js"
import JibGame from "./game/JibGame.js";

const canvasWrapper = document.getElementById('canvas-wrapper')
const buttonUp = document.getElementById('button-up')
const buttonDown = document.getElementById('button-down')
const countdownWrapper = document.getElementById('countdown')
let inputs = []
let game = []
let userLeft = false
let dateInterval = null

window.addEventListener('blur', function() {
	userLeft = true
});

document.addEventListener("DOMContentLoaded", () => {
	window.inputs = inputs;

	if (canvasWrapper !== null) {
		game = new JibGame();
		game.onGameEnd = function () {
			document.getElementById('game-over').classList.remove('d-none')
			document.getElementById('button-up').classList.add('disabled')
			document.getElementById('button-down').classList.add('disabled')

			clearInterval(dateInterval);

			inputs.push({
				id: game.id,
				frame: game.frameCount,
				action: 'k',
			});

			saveInputs();

			$.nette.ajax({
				url: window.app.scoreEndpoint,
				data: {
					score: game.state.score.value
				},
				success: function () {
					setInterval(function () {
						// Commucation - Check state and redirect once game ended
						$.nette.ajax({
							url: window.app.stateEndpoint,
							success: function (payload) {
								if (payload.state === 3) {
									window.location.href = window.app.endUrl;
								}
							}
						});
					}, 1000);
				}
			});
		}

		game.onGameFrame = function () {
			if (userLeft) {
				game.kill()
			}
		}

		const interval = setInterval(function () {
			$.nette.ajax({
				url: window.app.stateEndpoint,
				success: function (payload) {
					if (payload.state === 2) {
						userLeft = false
						document.getElementById('page-waiting').classList.add('d-none')
						document.getElementById('page-info').classList.add('d-none')
						document.getElementById('page-game').classList.remove('d-none')
						let countdown = 4;
						let countdownTimer = setInterval(function () {
							if (countdown <= 0) {
								clearInterval(countdownTimer)
								countdownWrapper.classList.add('d-none')
								buttonDown.classList.remove('disabled')
								buttonUp.classList.remove('disabled')
								game.resetGame()
							}
							document.getElementById("countdown").innerText = countdown
							countdown -= 1
						}, 1000)
						clearInterval(interval)

						dateInterval = setInterval(saveInputs, 2000);
					}
				}
			})
		}, 500)

		initControls()
	}
})

function saveInputs() {
	const inputsToBeStored = inputs.slice(0);
	inputs = [];

	if (inputsToBeStored.length > 0) {
		$.nette.ajax({
			type: 'POST',
			url: window.app.dateEndpoint,
			data: {
				inputs: JSON.stringify(inputsToBeStored)
			},
			success: function () {
				console.log(inputsToBeStored)
			},
			off: ['unique']
		});
	}
}

function initControls() {
	// Touch control
	buttonUp.addEventListener('touchstart', function (e) {
		performAction(e, 'j')
	})

	buttonDown.addEventListener('touchstart', function (e) {
		performAction(e, 'd')
	})

	buttonDown.addEventListener('touchend', function (e) {
		performAction(e, 's')
	})

	// Mouse control
	buttonUp.addEventListener('mousedown', function (e) {
		performAction(e, 'j')
	})

	buttonDown.addEventListener('mousedown', function (e) {
		performAction(e, 'd')
	})

	buttonDown.addEventListener('mouseup', function (e) {
		performAction(e, 's')
	})
}

function performAction(event, action) {
	game.onInput(action)

	inputs.push({
		id: game.id,
		frame: game.frameCount,
		action: action,
	});

	event.preventDefault()
	event.stopPropagation()
}
